import { createFileRoute } from "@tanstack/react-router";

import { JourneyPage } from "@/components/journey-page";

export const Route = createFileRoute("/body")({
  head: () => ({
    meta: [
      { property: "og:url", content: "https://www.luizajesusdoprado.com/body" },
      { title: "Body — Performance & Live Action | Luiza Jesus do Prado" },
      {
        name: "description",
        content:
          "Live action, performance, theatre and butoh works by Luiza Jesus do Prado — the body as laboratory.",
      },
      { property: "og:title", content: "Body — Performance & Live Action | Luiza Jesus do Prado" },
      {
        property: "og:description",
        content: "Live action, performance, theatre and ritual practice.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => <JourneyPage journeyKey="body" />,
});
